
export class MemberInfo {
    iNumber: string;
    firstName: string;
    lastName: string;
    preferredName: string;
    sex: string;
    isAttending: boolean;
    emailAddress: string;
    privacyMessage: string;
    byuIdahoPhotoBase64: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    localPhone: string;
    cellPhone: string;
    birthday?: Date;
    homeCity: string;
    homeState: string;
    homeChurchUnit: string;
    email: string;
    track: string;
    missionName: string;
    phone: string;
    appartmentAddress: string;
    appartmentNumber: string;
    isReturnMissionary: boolean;
}
